import { useInfiniteQuery } from '@tanstack/react-query'
import { useDebounce } from 'use-debounce'

import { useApi } from './api'
import { getCancellationToken } from './core'

import { queryify, queryKeys, getCancellable } from './queries-common'

export const useWasteCarriers = (
  searchTerm: string | null = null,
  expireAfter: string | null = null
) => {
  const api = useApi()

  const [debouncedSearchTerm] = useDebounce(searchTerm, 300, {
    trailing: true,
    leading: false
  })

  return useInfiniteQuery(
    [queryKeys.getWasteCarriers, !!api, debouncedSearchTerm],
    context => {
      if (!api) {
        return getCancellable()
      }

      const maybeContinuationToken = context.pageParam
      if (maybeContinuationToken === false) {
        return
      }

      const cancellationToken = getCancellationToken()

      return queryify(
        api.getWasteCarriers({
          pageSize: 100,
          continuationToken: maybeContinuationToken,
          searchTerm: debouncedSearchTerm,
          expireAfter: expireAfter,
          cancelToken: cancellationToken.token
        }),
        cancellationToken.cancel
      )
    },
    {
      getNextPageParam: page => {
        return page && page.hasNextPage && page.continuationToken
      },
      getPreviousPageParam: () => false,
      keepPreviousData: true
    }
  )
}

export const useWasteFacilities = (
  searchTerm: string | null = null,
  expireAfter: string | null = null
) => {
  const api = useApi()

  const [debouncedSearchTerm] = useDebounce(searchTerm, 300, {
    trailing: true,
    leading: false
  })

  return useInfiniteQuery(
    [queryKeys.getWasteFacilities, !!api, debouncedSearchTerm],
    context => {
      if (!api) {
        return getCancellable()
      }

      const maybeContinuationToken = context.pageParam
      if (maybeContinuationToken === false) {
        return
      }

      const cancellationToken = getCancellationToken()

      return queryify(
        api.getWasteFacilities({
          pageSize: 100,
          continuationToken: maybeContinuationToken,
          searchTerm: debouncedSearchTerm,
          expireAfter: expireAfter,
          cancelToken: cancellationToken.token
        }),
        cancellationToken.cancel
      )
    },
    {
      getNextPageParam: page => {
        return page && page.hasNextPage && page.continuationToken
      },
      getPreviousPageParam: () => false,
      keepPreviousData: true
    }
  )
}
